import { graphql } from "gql";

export const REMOVE_VULN_MUTATION = graphql(`
  mutation RemoveVulnerabilityMutation(
    $id: String!
    $findingId: String!
    $justification: RemoveVulnerabilityJustification!
  ) {
    removeVulnerability(
      id: $id
      findingId: $findingId
      justification: $justification
    ) {
      success
    }
  }
`);
